import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Link } from '@zola/zola-ui';
import { openModal } from 'cards/actions/modalActions';
import FeatureFlags from '../../../../util/featureFlags';

import './Bleed.less';

const Bleed = ({ height, width, verticalBleed, horizontalBleed, showModal, isRounded }) => {
  const bleedRedesign = FeatureFlags.get('bleedRedesign');
  const widestBleed = verticalBleed >= horizontalBleed ? verticalBleed : horizontalBleed;
  const bleedStyle = {
    top: `${verticalBleed}pt`,
    left: `${horizontalBleed}pt`,
    height: `${height - verticalBleed * 2}pt`,
    width: `${width - horizontalBleed * 2}pt`,
    // make bleed outline wider than necessary extra will be hidden by overflow hidden
    outlineWidth: `${widestBleed * 1.5}pt`,
    pointerEvents: 'none',
  };

  if (verticalBleed && horizontalBleed) {
    return (
      <div className="bleed">
        <div
          className={cx('bleed__inner-wrapper', {
            'bleed__inner-wrapper--is-rounded': isRounded,
          })}
        >
          <div className="bleed__line" style={bleedStyle}>
            {!bleedRedesign && (
              <div className="graphic">
                <div className="text text--is-underlined">
                  Keep content inside this line to ensure it will be printed
                </div>
                <div className="line" />
                <div className="circle" />
              </div>
            )}
          </div>
        </div>
        {bleedRedesign && (
          <div className="bleed__infoBubble">
            Keep important content inside this line. Content outside will still be printed but may
            be trimmed.{' '}
            <Link role="button" inline onClick={() => showModal('BLEED_MODAL')}>
              Learn More
            </Link>
          </div>
        )}
      </div>
    );
  }
  return null;
};

Bleed.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  verticalBleed: PropTypes.number,
  horizontalBleed: PropTypes.number,
  showModal: PropTypes.func,
  isRounded: PropTypes.bool,
};

const mapDispatchToProps = dispatch => ({
  showModal: modalName => dispatch(openModal(modalName, {}, { className: 'bleed__modal' })),
});

export default connect(null, mapDispatchToProps)(Bleed);



// WEBPACK FOOTER //
// ./src/cards/components/Customization/Preview/Bleed.jsx